export default "__VITE_ASSET__Bxut5PaF__"